/*
These functions make sure WordPress
and Foundation play nice together.
*/

jQuery(document).ready(function($) {
	
	// Remove empty P tags created by WP inside of Accordion and Orbit
	jQuery('.accordion p:empty, .orbit p:empty').remove();

	// Adds Flex Video to YouTube and Vimeo Embeds
	jQuery('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function() {
		if ( jQuery(this).innerWidth() / jQuery(this).innerHeight() > 1.5 ) {
		  jQuery(this).wrap("<div class='widescreen responsive-embed'/>");
		} else {
		  jQuery(this).wrap("<div class='responsive-embed'/>");
		}
	});

	$(".t1-1").each(function(){
		$(this).addClass('open');
	});

	$(".t1-2").each(function(){
		$(this).addClass('open');
	})

	$(".t1-3").each(function(){
		$(this).addClass('open');
	})
	$(".t1-4").each(function(){
		$(this).addClass('open');
	});

	$(".t1-5").each(function(){
		$(this).addClass('open');
	})

	$(".t1-6").each(function(){
		$(this).addClass('open');
	})
	$(".t1-7").each(function(){
		$(this).addClass('open');
	});
	$(".t1-8").each(function(){
		$(this).addClass('open');
	});


	setTimeout(function(){ 	$('.filter-banner.hidden').fadeIn(1500).removeClass('hidden'); }, 500);


	setTimeout(function(){ 	$('.logo.hidden').fadeIn(1000).removeClass('hidden'); 500}, 0);


	setTimeout(function(){ 	$('.watermark.hidden').fadeIn(1000).removeClass('hidden'); }, 3000);


	$(window).scroll(function() {

		var sticky = $('header'),
		scroll = $(window).scrollTop();

		if (scroll >= 200) sticky.addClass('fixed');
		else sticky.removeClass('fixed');

		var backToTop = $('.back-to-top'),
		scroll = $(window).scrollTop();
		if (scroll >= 700) backToTop.addClass('open');
		else backToTop.removeClass('open');

		var windowBottom = $(this).scrollTop() + $(this).innerHeight();
		
		
		$(".fade").each(function() {
		  /* Check the location of each desired element */
		  var objectBottom = $(this).offset().top + $(this).outerHeight();
		  
		  /* If the element is completely within bounds of the window, fade it in */
		  if ((objectBottom-400) < windowBottom) { 
			if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
		  }
		});


		$(".fade-last").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-200) < windowBottom) { 
			  if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
			}
		});

		$(".fade-test").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-700) < windowBottom) { 
			  if ($(this).css("opacity")==0) {$(this).fadeTo(1000,1);}
			}
		});


		$(".anim-heading").each(function() {
			/* Check the location of each desired element */
			var objectBottom = $(this).offset().top + $(this).outerHeight();
			
			/* If the element is completely within bounds of the window, fade it in */
			if ((objectBottom-200) < windowBottom) { 
			  $(this).addClass('open')
			}

			if(objectBottom > windowBottom) {
				$(this).removeClass('open')
			}
		});



	  }).scroll();

	  
	  

	  // Select all links with hashes
$('a[href*="#"]')
// Remove links that don't actually link to anything
.not('[href="#"]')
.not('[href="#0"]')
.click(function(event) {
  // On-page links
  if (
	location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') 
	&& 
	location.hostname == this.hostname
  ) {
	// Figure out element to scroll to
	var target = $(this.hash);
	target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
	// Does a scroll target exist?
	if (target.length) {
	  // Only prevent default if animation is actually gonna happen
	  event.preventDefault();
	  $('html, body').animate({
		scrollTop: target.offset().top
	  }, 1000, function() {
		// Callback after animation
		// Must change focus!
		var $target = $(target);
		$target.focus();
		if ($target.is(":focus")) { // Checking if the target was focused
		  return false;
		} else {
		  $target.attr('tabindex','-1'); // Adding tabindex for elements not focusable
		  $target.focus(); // Set focus again
		};
	  });
	}
  }
});


$(".elliott-lorenz").addClass('open');
$("#elliott-lorenz").addClass('open');


$(".teamitem").each(function(){
	$(this).on('click', function(){
		 id = $(this).attr('id')
		 console.log(id)

		 $(".member").each(function(){
			$(this).removeClass('open')
		})

		 if($(this).hasClass('open')){
			$(this).removeClass('open')
		 } else {
			$(this).addClass('open')
		 }
		 

		 
		 $(".desc").each(function(){
			 if($(this).hasClass(id)){
				$(this).addClass('open')
			 } else {
				$(this).removeClass('open')
			 }

		 })
	})
});



	  let headerBtn = $('.header__btn');
        let headerLinks = $('.nav');
        let header = $('.header');
        headerBtn.click(function (e) {
            e.preventDefault();
            headerLinks.toggleClass('open');
            headerBtn.toggleClass('open');
            header.toggleClass('open');

        });

		headerLinks.click(function (e) {
            e.preventDefault();
            headerLinks.toggleClass('open');
            headerBtn.toggleClass('open');
            header.toggleClass('open');

        });



   $('.step-1').on('click', function(){
	$('.step-2').removeClass('active');
	$('.step-3').removeClass('active');
	$(this).addClass('active');
		$('#step-text2').removeClass('active');
		$('#step-text3').removeClass('active');
		$('#step-text1').addClass('active');
		$('#step-text2a').removeClass('active');
		$('#step-text3a').removeClass('active');
		$('#step-text1a').addClass('active');
   	}   
   )
   
   $('.step-2').on('click', function(){
	$('.step-1').removeClass('active');
	$('.step-3').removeClass('active');
	$(this).addClass('active');
		$('#step-text1').removeClass('active');
		$('#step-text3').removeClass('active');
		$('#step-text2').addClass('active');
		$('#step-text1a').removeClass('active');
		$('#step-text3a').removeClass('active');
		$('#step-text2a').addClass('active');
   	}   
   )

   $('.step-3').on('click', function(){
	$('.step-2').removeClass('active');
	$('.step-1').removeClass('active');
	$(this).addClass('active');
	$('#step-text1').removeClass('active');
	$('#step-text2').removeClass('active');
	$('#step-text3').addClass('active');
	$('#step-text1a').removeClass('active');
	$('#step-text2a').removeClass('active');
	$('#step-text3a').addClass('active');
   	}   
   )


   $('#site-navigation').on('click', function(){
		$('.header').removeClass('open');
		headerLinks.removeClass('open');
            headerBtn.removeClass('open');
            header.removeClass('open');
   })


   var slideIndex = 0;

   carousel();
   
   function carousel() {
	 var i;
	 var x = document.getElementsByClassName("step");
	 for (i = 0; i < x.length; i++) {
	   x[i].classList.remove('active')
	 }
	 slideIndex++;
	 if (slideIndex > x.length) {slideIndex = 1}
	 x[slideIndex-1].classList.add('active')
	 myVar2 = setTimeout(carousel, 4000); // Change image every 2 seconds
	 $('.grey-box').on('click', function(){
		clearTimeout(myVar2);
	 })

   }
 
   var slideIndex2 = 0;
   carousel2();
   
   function carousel2() {
	 var k;
	 var z = document.getElementsByClassName("s3");
	 for (k = 0; k < z.length; k++) {
	   z[k].classList.remove('active')
	 }
	 slideIndex2++;
	 if (slideIndex2 > z.length) {slideIndex2 = 1}
	 z[slideIndex2-1].classList.add('active')
	 myVar = setTimeout(carousel2, 4000); // Change image every 2 seconds
	 $('.grey-box').on('click', function(){
		clearTimeout(myVar);
	 })

	 var slideIndex3 = 0;
	 carousel3();
	 
	 function carousel3() {
	   var j;
	   var y = document.getElementsByClassName("s2");
	   for (j = 0; j < y.length; j++) {
		 y[j].classList.remove('active')
	   }
	   slideIndex3++;
	   if (slideIndex3 > y.length) {slideIndex3 = 1}
	   y[slideIndex3-1].classList.add('active')
	   myVar8 = setTimeout(carousel3, 4000); // Change image every 2 seconds
	   $('.grey-box').on('click', function(){
		  clearTimeout(myVar8);
	   })}


   }


	 
});



window.onload = function(){
	// var slides = document.getElementsByClassName('step'),
	// 	addActive = function(slide) {slide.classList.add('active')},
	// 	removeActive = function(slide) {slide.classList.remove('active')};
	// addActive(slides[0]);
	
	// setInterval(function (){
	//   for (var i = 0; i < slides.length; i++){
	// 	// if (i + 1 == slides.length) {
	// 	//   addActive(slides[0]);
	// 	// //   slides[0].style.zIndex = 100;
	// 	//   setTimeout(removeActive, 350, slides[i]); //Doesn't be worked in IE-9
	// 	//   break;
	// 	// }
	// 	if (slides[i].classList.contains('active')) { 
	// 	//   slides[i].removeAttribute('style');
	// 	  setTimeout(removeActive, 350, slides[i]); //Doesn't be worked in IE-9
	// 	  addActive(slides[i + 1]);
	// 	  break;
	// 	}
	//   } 
	// }, 4000);
  }



